export const humanitarian = [
  { value: '1', label: 'True' },
  { value: '0', label: 'False' },
];

export const secondaryReporter = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];
